import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { Icon } from '../icon/icon';
import { icon } from '../../icons/processed/check-mark.svg';
export var roundNotificationKey = 'round-notification';
export var RoundNotificationType;
(function (RoundNotificationType) {
    RoundNotificationType[RoundNotificationType["INFO"] = 1] = "INFO";
    RoundNotificationType[RoundNotificationType["ALERT"] = 2] = "ALERT";
    RoundNotificationType[RoundNotificationType["WARNING"] = 3] = "WARNING";
    RoundNotificationType[RoundNotificationType["CHECK"] = 4] = "CHECK";
})(RoundNotificationType || (RoundNotificationType = {}));
var RoundNotification = /** @class */ (function (_super) {
    __extends(RoundNotification, _super);
    function RoundNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    RoundNotification.prototype.render = function () {
        var _a;
        var _b = this.props, _c = _b.max, max = _c === void 0 ? 0 : _c, _d = _b.count, count = _d === void 0 ? 0 : _d, type = _b.type, className = _b.className;
        var notificationType = RoundNotificationType[type].toLowerCase();
        var maybeHighNumber = count > 9;
        var classNames = namespacedClassnames(roundNotificationKey, notificationType, { high: maybeHighNumber }, (_a = {}, _a[className || ''] = !!className, _a));
        var countText = ((max > 0) && (count > max)) ? "+" + max : "" + count;
        var body = type === RoundNotificationType.CHECK
            ? React.createElement(Icon, { icon: icon })
            : count
                ? countText
                : React.createElement("div", { className: 'dot' });
        return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: 'count' }, body)));
    };
    return RoundNotification;
}(React.Component));
export { RoundNotification };
//# sourceMappingURL=index.js.map